import Vue from 'vue'
import Router from 'vue-router'
import Jobs from '@/components/Jobs'
import Job from '@/components/Job'
import Callback from '@/components/Callback'
import Hello from '@/components/Hello'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/jobs',
      name: 'Jobs',
      component: Jobs
    },
    {
      path: '/job/:dataset',
      name: 'Job',
      component: Job,
      props: true
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js